module.exports = {"version":"0.3.23"}


//////////////////
// WEBPACK FOOTER
// ./src/version.json
// module id = 281
// module chunks = 0